import { type RemovalStatus, removalRequestSchema } from "../../schemas/athlete";
import { fetchApi, fetchVoid, paginatedSchema, toSearchParams } from "../internal";

export const REMOVALS_PAGE_SIZE = 20;
export type RemovalRequestsListParams = {
	status?: RemovalStatus;
	limit?: number;
	offset?: number;
};

export const removals = {
	approve: (id: string) => fetchVoid(`/admin/athletes/removals/${id}/approve`, { method: "POST" }),
	list: ({ limit = REMOVALS_PAGE_SIZE, offset = 0, status }: RemovalRequestsListParams = {}) => {
		const qs = toSearchParams({ limit, offset, status });
		return fetchApi(`/admin/athletes/removals?${qs}`, paginatedSchema(removalRequestSchema));
	},
	reject: (id: string) => fetchVoid(`/admin/athletes/removals/${id}/reject`, { method: "POST" }),
};
